import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2';
import '../../css/notice.css';

const Notice = ({ trigger, setTrigger }) => {

    const [noticeList, setNoticeList] = useState([]);

    const fetchNotice = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/notice`)
            if (response.data.status === "Success") {
                setNoticeList(response.data.detail)
            }
            else {
                Swal.fire('Unable to get data from server!', '', 'error');
                setTrigger(false);
            }
        }
        catch (error) {
            console.error("Error fetching notice:", error);
        }
    }

    const activeNotice = noticeList.filter((nItem) => {
        return nItem.Status === 1;
    });

    useEffect(() => {
        fetchNotice();
    }, [])

    return (trigger) ? (
        <section>
            <div className="notice-container">
                <div className="notice">
                    <button className='close-btn' onClick={() => setTrigger(false)}>
                        <i className='bi bi-x cross-icon' />
                    </button>
                    {
                        activeNotice.length > 0 ? activeNotice.map((item, index) => {
                            return (
                                <div key={index} className='notice-item'>
                                    <div className='notice-image'>
                                        <img src={`${process.env.REACT_APP_IMG_URL}/notices/${item.NoticePhoto}`} alt='notice' />
                                    </div>
                                </div>
                            )
                        }) : setTrigger(false)
                    }
                </div>
            </div>
        </section>
    ) : '';
}

export default Notice